module.exports = __webpack_public_path__ + "img/blanc_large.29fbc853.svg";